import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { TierAccumulationType, TierHistoryRow } from '@models/tier';
import dayjs from 'dayjs';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
    record: TierHistoryRow;
    accumulationType?: TierAccumulationType;
}

function RecordRow({ record, accumulationType }:Props) {
    const { t } = useTranslation('tier');
    const {
        shopName, value, occurredAt, type,
    } = record;
    const priceUnit = usePriceUnit();
    const unit = accumulationType === 'STAMP' ? '개' : priceUnit;
    const typeLabel = type === 'EARN' ? t('tierHistory.typeEarn') : t('tierHistory.typeCancel');
    return (
        <Container spacing={3} fullWidth>
            <Text fontWeight='medium' size='title'>{shopName}</Text>
            <Row fullWidth justify='space-between'>
                <Text size='body-long' color={colors.textThird}>
                    {t('tierHistory.record', {
                        type: typeLabel,
                        value: `${value >= 0 ? '+' : ''}${value.toLocaleString()}`,
                        unit,
                    })}
                </Text>
                <Text size='body-long' color={colors.textThird}>
                    {dayjs(occurredAt).format('YYYY.MM.DD')}
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Column)`
    padding:16px 0;
    border-bottom: 1px solid var(--color-gray2);
    &:nth-last-of-type(1) {
        border: none;
    }
`;

export default RecordRow;
